/**
 * Locale API client
 * Fetches available languages and countries (with currency codes)
 */

import { getEnv } from "@/config/env";
import { getJson } from "@/api/http";
import type { Result } from "@/types/layout";

export interface CountryWithCurrency {
  countryCode: string;
  currencyCode: string | null;
  displayNames: { languageCode: string; name: string }[];
  validCultures: { languageCode: string; cultureCode: string }[];
}

export interface LocaleOptions {
  languages: { languageCode: string; displayName: string }[];
  countries: CountryWithCurrency[];
}

const LOCALE_OPTIONS_ENDPOINT = "/locale/options";

/**
 * Fetches available languages and countries with their currency codes
 */
export async function fetchLocaleOptions(): Promise<Result<LocaleOptions>> {
  const url = `${getEnv().apiBaseUrl}${LOCALE_OPTIONS_ENDPOINT}`;
  return getJson<LocaleOptions>(url);
}
